import React, { useState, setState, useEffect, createContext, useContext, useCallback, useMemo, useRef } from 'react';
import CustomStore from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';
import './Documenti.scss';
import axios from 'axios';
import appInfo from '../../app-info';
import ColorCell from './ColorCell.js';
import { custom } from 'devextreme/ui/dialog';
import Form, { Item, EmptyItem, TabbedItem, Tab, TabPanelOptions, GroupItem, Label } from 'devextreme-react/form';
// import { FileUploader } from 'devextreme-react/file-uploader';
import Verticalmemolist from '../../components/vertical-memo-list/vertical-memo-list';
import { FileUploaderForm } from '../../components';
import { PieMultiple } from '../../components';
import SwitchCell from '../../components/toogle-button/toogle-button';
import { CheckBox } from 'devextreme-react/check-box';
import Guid from 'devextreme/core/guid';
import ScrollView from "devextreme/ui/scroll_view"

import DataGrid, {
    Column,
    Pager,
    Paging,
    FilterRow,
    Lookup,
    ColumnChooser,
    ColumnFixing,
    StateStoring,
    HeaderFilter,
    GroupPanel,
    Button,
    Editing,
    RequiredRule,
    FilterPanel,

} from 'devextreme-react/data-grid';

import {
    validationRules,
    positionEditorOptions,
    notesEditorOptions,
    phoneEditorOptions
} from './../../ValidationRulesAndEditorOptions.js';

import Popup, { ToolbarItem } from 'devextreme-react/popup';
import validationEngine from 'devextreme/ui/validation_engine';
import AddRowButton from 'devextreme-react/button';
import 'devextreme-react/text-area';

import { createStore } from 'devextreme-aspnet-data-nojquery';
import { useAuth } from '../../contexts/auth';
import { formatDate } from 'devextreme/localization';
import { ToggleButtonCell } from '../../components';

import BannerDownload from '../../components/banners/banner-download.js';

export default function App(props) {

    const validationGroupName = "gridForm";

    const url = appInfo.urlWebApi;
    const { user } = useAuth();
    var extraParam;

    const [seed, setSeed] = useState(1);

    const store = new CustomStore({
        key: ['ID', "ID_ALLEGATO"],
        load: (loadOptions) => {
            return axios.get(url + '/api/Documenti/Get?key=', { params: { internalKey: user.internalKey, userType: user.userType, id: user.id } });
        },
        insert: (values) => {
            return axios.put(url + '/api/Documenti/Put?', null, { params: { key: values.ID, values: JSON.stringify(values), internalKey: user.internalKey, userType: user.userType, id: user.id, newid: newGuid } });
        },
        update: (key, values) => {
            return axios.put(url + '/api/Documenti/Update?', null, { params: { key: key, values: JSON.stringify(values), internalKey: user.internalKey, newid: newGuid } });
        },
        remove: (key) => {
            return axios.delete(url + '/api/Documenti/Delete', { params: { internalKey: user.internalKey, extraParam: extraParam } });
        },
        onBeforeSend: (method, ajaxOptions) => {
            ajaxOptions.xhrFields = { withCredentials: false };
        },
    });

    const dataSource = new DataSource({
        store: store,
        refreshMode: 'reshape',
    });

    const gridRef = useRef(null);
    const [{ isNewRecord, formData, visible, newGuid }, setPopupState] = useState({});

    const showPopup = useCallback((isNewRecord, formData) => {
        var newGuid = new Guid().toString();
        setPopupState({ isNewRecord, formData, visible: true, newGuid });
    }, []);

    const hidePopup = useCallback(() => {
        setPopupState({ visible: false });
    }, []);

    const confirmChanges = useCallback(async () => {
        const result = validationEngine.validateGroup(validationGroupName);

        if (!result.isValid)
            return;

        if (isNewRecord)
            await store.insert(formData);
        else
            await store.update(formData["ID"], formData);

        await store.load();

        hidePopup();

    }, [isNewRecord, formData, hidePopup]);


    const confirmBtnOptions = useMemo(() => {
        return {
            text: "Salva",
            type: "success",
            onClick: confirmChanges
        }
    }, [confirmChanges]);

    const cancelBtnOptions = useMemo(() => {
        return {
            text: "Annulla",
            onClick: hidePopup
        }
    }, [hidePopup]);

    const editRow = useCallback((e) => {
        showPopup(false, { ...e.row.data });
    }, [showPopup]);



    const addRow = useCallback((e) => {
        showPopup(true, { ...e.row.data });
    }, [showPopup]);

    const deleteRow = useCallback(async (e) => {
        let customDeleteConfirmDialog = custom({
            showTitle: false,
            messageHtml: "Sicuro di voler rimuore questo documento?",
            buttons: [{
                text: "Si",
                onClick: () => true
            }, {
                text: "No",
                onClick: () => false
            }]
        })

        customDeleteConfirmDialog.show().then(async (dialogResult) => {
            if (dialogResult) {
                extraParam = e.row.data.ID_ALLEGATO;
                await store.remove(e.row.data.ID);
            }
        }).then(async function () {     
            dataSource.reload();
            setSeed(Math.random());
        })
    }, [dataSource, seed]);

   
    function addDays(date, days) {
        var result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;
    }

    function calculateCellValue(data) {
        var status;

        var dateNow = new Date()
        dateNow.setHours(0, 0, 0);

        if (data.ID_ALLEGATO != 0 && data.ID_ALLEGATO != null) {
            if (data.DATA_SCADENZA == null)
                status = 'Non presente';
            else if (Date.parse(data.DATA_SCADENZA) < Date.parse(dateNow))
                status = 'Scaduto';
            else if (Date.parse(data.DATA_SCADENZA) >= Date.parse(dateNow) && Date.parse(data.DATA_SCADENZA) < Date.parse(addDays(dateNow, 15)))
                status = 'In scadenza';
            else
                status = 'Valido';
        }
        else {
            status = 'Non presente';
        }

        return status;
    }



    function base64ToArrayBuffer(base64) {
        var binaryString = atob(base64);
        var bytes = new Uint8Array(binaryString.length);
        for (var i = 0; i < binaryString.length; i++) {
            bytes[i] = binaryString.charCodeAt(i);
        }
        return bytes.buffer;
    }



    async function GetDocumento(ID_ALLEGATO) {

        if (user) {
            const instance = axios.create({
                baseURL: url,
                timeout: 50000,
                headers: { 'X-Custom-Header': 'foobar' }
            });

            await instance.get('/api/Documenti/DownloadFile', {
                params: { internalKey: user.internalKey, idAllegato: ID_ALLEGATO }
            })
                .then(function (response) {

                    var bytes = base64ToArrayBuffer(response.data.dataObject);

                    const url = window.URL.createObjectURL(new Blob([bytes]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', response.data.fileName); //or any other extension
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                })
                .catch(function () {
                    // imgLogo = { isOk: false, message: "Errore di connessione al servizio Web", data: null };
                })
                .finally(function () { });
        }
        else {
            return null;
        }
    }
    async function GetModello(ID) {
        if (user) {
            const instance = axios.create({
                baseURL: url,
                timeout: 50000,
                headers: { 'X-Custom-Header': 'foobar' }
            });

            await instance.get('/api/Documenti/DownloadModello', {
                params: { internalKey: user.internalKey, id: ID }
            })
                .then(function (response) {

                    var bytes = base64ToArrayBuffer(response.data.dataObject);

                    const url = window.URL.createObjectURL(new Blob([bytes]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', response.data.fileName); //or any other extension
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                })
                .catch(function () {
                    // imgLogo = { isOk: false, message: "Errore di connessione al servizio Web", data: null };
                })
                .finally(function () { });
        }
        else {
            return null;
        }
    }


    function getUrlUpload() {
        return url + '/api/Documenti/Post?internalKey=' + user.internalKey + '&newid=' + newGuid;
    }

    function downloadFile(e) {
        GetDocumento(e.row.data.ID_ALLEGATO);
    }
    function downloadModello(e) {
        GetModello(e.row.data.ID);
    }

    function onClickDownload(e){
        GetModello(e.ID);
    }

    function onChangeFileUpload(result, value) {
        // dataSourceAllegati.reload();
    }

    //INIT GRID
    function onAllowAdding(e) {
        return !(e.row.data.IS_UPLOADED);
    }
    function onAllowDeleting(e) {
        return (e.row.data.IS_UPLOADED);
    }
    function onAllowDownloading(e) {
        return (e.row.data.IS_UPLOADED);
    }
    function onAllowUpdating(e) {
        return (e.row.data.IS_UPLOADED);
    }
    function onAllowModello(e){
        console.log(e);
        return (e.row.data.HAS_MODELLO)
    }
    //END

    return (
        <React.Fragment>
            <h2 className={'content-block'}>Elenco documenti</h2>
            <p className={'content-block'}>
                <b>L’inserimento dei documenti richiesti è propedeutico all’emissione del/i contratto/i di subappalto lavoro e/o degli ordini di lavoro.<br /></b>
                <span style={{ color: 'red' }}>
                    Nel caso sia necessario richiedere l'esclusione di uno o più documenti richiesti in quanto non pertinenti all'attività è possibile farlo nell'apposita sezione
                    "MESSAGGI" (Menù a sinistra) motivando la richiesta.
                </span>
                <br/>
                <span style={{ color: 'red' }}>
                    PROBLEMI DI VISUALIZZAZIONE: Nel caso di monitor con risoluzioni basse è possibile migliorare la visualizzazione impostando a 60/80% lo Zoom del browser (metodo rapido CTRL + Rotella del mouse).
                </span>
            </p>
            <div className='documenti-grid-height'>
                <DataGrid
                    id='gridContainer'
                    className={'dx-card wide-card'}
                    dataSource={dataSource}
                    ref={gridRef}
                    showBorders={false}
                    focusedRowEnabled={true}
                    defaultFocusedRowIndex={0}
                    columnAutoWidth={true}
                    repaintChangesOnly={true} >

                    <Pager showPageSizeSelector={true} allowedPageSizes={[5, 10, 20]} showInfo={true} />
                    <HeaderFilter visible={true} />
                    <FilterRow visible={true} />
                    <FilterPanel visible={false} />
                    <ColumnChooser enabled={false} mode="select" />

                    <GroupPanel visible={false} emptyPanelText="Trascinare qui le intestazioni di colonna per creare raggruppamenti..." />

                    <Pager showPageSizeSelector={true} showInfo={true} />
                    <FilterRow visible={true} />

                    <Column dataField={'ID'} width={90} hidingPriority={2} visible={false} />


                    <Column type="buttons" width={120} caption="AZIONI">
                        <Button name="add" visible={onAllowAdding} onClick={addRow} hint="Aggiungi" />
                        <Button name="edit" visible={onAllowUpdating} onClick={editRow} />
                        <Button icon="download" visible={onAllowDownloading} onClick={downloadFile} hint="Scarica documento" />
                        <Button name="delete" visible={onAllowDeleting} onClick={deleteRow} />
                    </Column>
                    <Column type="buttons" width={40}>
                        <Button icon="textdocument" visible={onAllowModello} onClick={downloadModello} hint="Esegui il download del modello da compilare e ricaricare" />                          
                    </Column>


                    <Column caption='DOCUMENTI' alignment={"center"}>

                        <Column
                            dataField={'DESCRIZIONE'}
                            witdh={300}
                            caption={'Descrizione'}
                        />
                        <Column
                            dataField={'RUOLI'}
                            witdh={300}
                            caption={'Ruoli'}
                        />
                        <Column
                            dataField={'DATA_CREATION'}
                            width={150}
                            caption={'Data caricamento'}
                            dataType="date"
                            format="dd-MM-yyyy"
                        />
                        <Column
                            dataField={'DATA_SCADENZA'}
                            width={150}
                            caption={'Data scadenza'}
                            dataType="date"
                            format="dd-MM-yyyy"
                        />
                        <Column
                            name={'STATUS'}
                            minWidth={130}
                            caption={'Stato'}
                            visible={true}
                            calculateCellValue={calculateCellValue}
                            cellRender={ColorCell}
                        ></Column>
                        <Column
                            dataField={'NOTE'}
                            caption={'Annotazioni aggiuntive'}
                            hidingPriority={-1}
                        />
                    </Column>

                </DataGrid>
            </div>
            <div className='documenti-bottom-place'>
                <div id="chart-demo" className='documenti-container-chart'>
                    <PieMultiple user={user} key={seed}></PieMultiple>
                </div>
            </div>

            {visible ? (
                <Popup
                    title={formData.Descrizione}
                    hideOnOutsideClick={true}
                    visible={true}
                    width={900}
                    height={"auto"}
                    onHiding={hidePopup}
                >
                    <ToolbarItem
                        widget="dxButton"
                        location="after"
                        toolbar="bottom"
                        options={confirmBtnOptions}
                    />
                    <ToolbarItem
                        widget="dxButton"
                        location="after"
                        toolbar="bottom"
                        options={cancelBtnOptions}
                    />



                    <Form colCount={3}
                        encType="multipart/form-data"
                        validationGroup={validationGroupName}
                        formData={formData}
                    >
                        <Item colSpan={3} >
                            {
                                formData.HAS_MODELLO ?
                                <BannerDownload formData={formData} onClick={onClickDownload} /> : null
                            }
                        </Item>
                       

                        <Item colSpan={3} visible={isNewRecord || calculateCellValue(formData) == 'Scaduto'  ? true : false}>
                            <FileUploaderForm showFileList={true} multiple={false} urlUpload={getUrlUpload()} userKey={user.key} dataField="ID" onChange={onChangeFileUpload} visible={true}>
                                <RequiredRule />
                            </FileUploaderForm>
                        </Item>

                        <EmptyItem colSpan={3}></EmptyItem>

                        <Item dataField="DATA_SCADENZA" editorType="dxDateBox" editorOptions={{ dateSerializationFormat: 'yyyy-MM-dd', displayFormat: 'dd-MM-yyyy' }} colSpan={1}>
                            <RequiredRule />
                        </Item>

                        <Item dataField="ASSUNZIONE_RESP" editorType="dxCheckBox" colSpan={2} editorOptions={{ iconSize: 25, height: 45}} >
                            <Label text={`Assunzione di responsabilità sulla veridicità del documento e della data di scadenza `} />
                            <RequiredRule />
                        </Item>

                        <EmptyItem colSpan={3}></EmptyItem>

                        <Item dataField="NOTE" editorType="dxTextArea" colSpan={3} editorOptions={{ height: 240 }}>
                        </Item>


                    </Form>

                </Popup>
            ) : null}

        </React.Fragment>
    );
}










